var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosInstance } from '@/api/realApi/_axios';
import { joinUrl } from '@/api/realApi/_utils';
import { getCsrfHeaders } from '@/api/realApi/authApi';
const ROOMS_URL_PATH = '/api/rooms/room/';
export const roomApi = {
    getRoomByCode: (roomCode) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([ROOMS_URL_PATH], [`code=${roomCode}`]));
        if (Array.isArray(res.data) && res.data.length > 0) {
            return res.data[0];
        }
        else if (res.data && res.data.results && res.data.results.length > 0) {
            return res.data.results[0];
        }
        else {
            throw new Error(res.data);
        }
    }),
    list: (createdById) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(ROOMS_URL_PATH, {
            params: {
                created_by: createdById,
            },
        });
        return res.data['results'] || res.data;
    }),
    create: (roomName) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(ROOMS_URL_PATH, { name: roomName }, config);
        return res.data;
    }),
    update: (id, data) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.patch(joinUrl([ROOMS_URL_PATH, id]), data, config);
        return res.data;
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.delete(joinUrl([ROOMS_URL_PATH, id]), config);
    }),
};
